import { Button, Col, Divider, Flex, Row, Typography } from 'antd'
import React from 'react'
import { Icon } from '~/features/shared/icons'

export const SocialButton = ({ name, redirectTo }) => {
  const Buttons = {
    google: (
      <Button block icon={<Icon name="google" />} size="large" type="primary">
        <Flex className="w-full" justify="center">
          Continue with Google
        </Flex>
      </Button>
    ),
    default: <Button block>{name}</Button>,
  }

  //encode url

  const encodedRedirectTo = encodeURIComponent(redirectTo || '/')

  const redirect = redirectTo ? `?redirectTo=${encodedRedirectTo}` : ''

  return (
    <a key={name} href={`/api/auth/${name}${redirect}`} className="w-full">
      {Buttons[name] ?? Buttons.default}
    </a>
  )
}

export const SocialButtons: React.FC<{
  providers: { name: string }[]
  redirectTo?: string
}> = ({ providers = [], redirectTo = '/' }) => {
  if (providers.length === 0) {
    return <></>
  }

  return (
    <>
      <Row>
        {providers.map((provider, index) => (
          <Col key={index} xs="auto" flex={1}>
            <SocialButton name={provider.name} redirectTo={redirectTo} />
          </Col>
        ))}
      </Row>

      <Divider>
        <Typography.Text type="secondary"> OR</Typography.Text>
      </Divider>
    </>
  )
}
